import React from 'react'
import { FaFacebookF,FaInstagram,FaTwitter,FaYoutube } from "react-icons/fa";
import { address, facebook_id, instagram_id, twitter_id, website_name, youtube_id } from '../../constants/themeConstants';
import { useNavigate } from 'react-router-dom';

 const options = [
    {icon:FaFacebookF,path:facebook_id},
    {icon:FaInstagram,path:instagram_id},
    {icon:FaYoutube,path:youtube_id}
 ]

const menu = [
  {name:'Home',path:'/home'},
  {name:'About',path:'/about'},
  {name:'Services',path:'/services'},
  {name:'Contact',path:'/contact_us'},
  {name:'Location',path:'/location'},
  {name:'Terms & Condition',path:'/terms_and_condition'},
  {name:'Privacy Policy',path:'/privacy_policy'},
  {name:'Contact Us',path:'/contact_us'},
]




function SideBar({closeMenu}) {


  const navigate = useNavigate()

  function openPage(m){
    navigate(m?.path)
    closeMenu()
  }

  return (
    <div className='p-4'>
        
        <div className='my-4 cursor-pointer'>
          
          {menu?.map((m)=>(
            <h6 onClick={()=>openPage(m)} className='font-body text-[13px] my-2'>{m?.name}</h6>
          ))}
        </div>

        <h6 className='text-[13px] font-body'>{address}</h6>

        <h6 className='text-[13px] font-body my-2'>© 2025 <span className='font-[700] font-heading'>{website_name}</span>. All Rights Reserved</h6>
        
        <div className='flex items-center my-4 '>
          {options?.map((o)=>(
              <div onClick={()=>window.open(o?.path,'_blank')} key={o?.path}  className={`mx-1 cursor-pointer transition-all duration-300 ease-in-out hover:scale-105 active:scale-95 rounded flex item-center justify-center hover:bg-[#7b026b] p-1.5 hover:text-white`}>
                <o.icon size={14} />
              </div>    
          ))}
        </div>
    </div>
  )
}

export default SideBar